module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/present-38a7907f18682419edc815354796215d.png";